import { FormMetaItem, InfoSettingsHelper } from "../../../../components/editors/form-editor/form-meta-config";

export class QuestionInfoDialog {

    title: string;
    moreInfo: string;

    activate(formMetaItem: FormMetaItem) {
        this.title = formMetaItem.info;
        this.moreInfo = InfoSettingsHelper.migrateInfoSettings(formMetaItem.infoSettings).infoDialog;
    }
}